import React from 'react';
import {Switch,Route,Redirect,withRouter,Link} from 'react-router-dom';
import {connect} from 'react-redux';
import { TransitionGroup } from 'react-transition-group';
import {uploadAudio,downloadAudio,
    downloadHindiText,loginUser,logoutUser,
    getStats,updateStatsServer,getAudioForVerification,
    audioVerificationResult} from '../redux/ActionCreator';
import Download from './Download';
import TrueWav from './TrueWav';
import Login from './Login';
import Dashboard from './Dashboard';
import Signup from './Signup';
import Header from './Header';
import Footer from './Footer';
import AdminTools from './adminTools';
import ResetPassword from './ResetPassword';
import EmailForgotPassword from './EmailForgotPassword';
import AudioVerification from './AudioVerification';
import Instruction from './Instructions';
import Ranking from './Ranking';
import RecordTroubleshoot from './RecordTroubleshoot';
import Certification from "./Certification";
import UploadFile from "./UploadFile"

// getting state from the state
// the store sends the state as props
const mapStateToProps = state =>{
    // console.log(state)
    return{
      audio: state.audio,
      hindiText: state.hindiText,
      user: state.user
    }
  }

const mapDispatchToProps = dispatch => ({
    uploadAudio: (fileNumber,hindiTextId,audioFile,language)=>dispatch(uploadAudio(fileNumber,hindiTextId,audioFile,language)),
    downloadAudio: ()=>dispatch(downloadAudio()),
    downloadHindiText: ()=> dispatch(downloadHindiText()),
    loginUser: (creds)=>dispatch(loginUser(creds)),
    logoutUser: ()=>dispatch(logoutUser()),
    getStats: ()=>dispatch(getStats()),
    updateStatsServer: (recorded)=>dispatch(updateStatsServer(recorded)),
    getAudioForVerification: (language) => dispatch(getAudioForVerification(language)),
    audioVerificationResult: (audioId,verificationResult)=>dispatch(audioVerificationResult(audioId,verificationResult))
});
  

class Main extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            audioFile:null,
            audioBase64:null,
            isPlaying:false,
            postRecord:"none",
            preRecord:"block"
        };
        // the recorder
        this.audioRef = React.createRef();
        // the playback
        this.retryRecording = React.createRef();
        this.saveRecording = React.createRef();
        // 
        this.recordedAudio = React.createRef();
        // console.log(this.props.audio);
        this.displayHindiText = React.createRef();
    }

    render(){
        return(
            <div>
                {/* <nav>
                    <Link to="/download">Home</Link>
                    <Link to="/trueWAV">TrueWAV</Link>
                </nav> */}
                <Header 
                    user={this.props.user}
                    logoutUser={this.props.logoutUser}
                    />
                <TransitionGroup>
                    <Switch>
                        <Route exact path="/login" component={()=><Login 
                            user={this.props.user} 
                            loginUser={this.props.loginUser}
                            getStats={this.props.getStats}
                            />}/>
                        <Route exact path="/signup" component={()=><Signup 
                            user={this.props.user} 
                            />}/>
                        <Route exact path="/dashboard" component={()=><Dashboard 
                            user={this.props.user} 
                            logoutUser={this.props.logoutUser}
                            uploadAudio={this.props.uploadAudio}
                            downloadAudio={this.props.downloadAudio}
                            downloadHindiText={this.props.downloadHindiText}
                            hindiText={this.props.hindiText}
                            updateStatsServer={this.props.updateStatsServer}
                            getStats={this.props.getStats}
                            getAudioForVerification={this.props.getAudioForVerification}
                            audioVerificationResult={this.props.audioVerificationResult}
                            />}/>
                        <Route exact path="/admin6089Tools"
                            component={()=><AdminTools
                            user={this.props.user}
                            />}
                        />
                        <Route path="/resetPassword/:token"
                            component={ResetPassword}
                        />
                        <Route exact path="/emailforgotpassword"
                            component={EmailForgotPassword}
                        />
                        {/* <Route exact path="/audio" component={()=><AudioVerification
                            user={this.props.user}
                            getAudioForVerification={this.props.getAudioForVerification}
                            />}/> */}
                        <Route exact path="/instruction"
                            component={Instruction}
                        />
                        <Route exact path="/ranks"
                            component={()=><Ranking
                            user={this.props.user}
                            />}
                        />
                        <Route exact path="/fixRecording"
                            component={RecordTroubleshoot}
                            />
                        {/* <Route exact path="/downloads"
                            component={TrueWav}
                        /> */}
                        <Route exact path="/uploadFile"
                            component={UploadFile}
                            />
                        <Route exact path="/home"
                            component={Certification}
                            />
                        <Redirect to="/home"/>
                    </Switch>
                </TransitionGroup>
                <div className="clear">
                </div>
                <Footer/>
            </div>
        );     
    }
}

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(Main));